var numeral = require("numeral");
import UtilFormat from "../../AxiomComponents/Utils.js"
var dateFormat = require("dateformat");


export class Utils {
  constructor() {}
  
  static max_date(all_dates) {
    var max_dt = all_dates[0],
      max_dtObj = new Date(all_dates[0]);
    all_dates.forEach(function(dt, index) {
      if (new Date(dt) > max_dtObj) {
        max_dt = dt;
        max_dtObj = new Date(dt);
      }
    });
    return max_dt;
  }
  static apply_format(input, format, unit) {
    return UtilFormat.apply_format(input,format, unit);
  }

  static apply_format_tooltip(input, format) {
    return format ? numeral(input).format(format) : input;
  }

  static get_kpi_unitname_2(unit) {
    switch (unit.toLowerCase()) {
      case "shorttextperiod":
      case "period":
        return "Period";
        break;
      case "percentage":
        return "";
        break;
      case "Rs.":
      case "INR":
        return "₹";
        break;
      default:
        return unit;
    }
  }

  static get_kpi_unitname(unit) {
    switch (unit) {
      case "ShortTextPeriod":
        return "in Period";
        break;
      case "Percentage":
      case "percentage":
        return "in %";
        break;
      case "Rs.":
      case "INR":
        return "in Rs.";
        break;
      default:
        return unit;
    }
  }

  static apply_unit_name(unit) {
    switch (unit) {
      case "ShortTextPeriod":
        return "Period";
        break;
      case "Percentage":
      case "percentage":
        return "";
        break;
      case "Rs.":
      case "INR":
        return "Rupees";
        break;
      default:
        return unit;
    }
  }

  static apply_format_unit(input, format, unit) {
    return UtilFormat.apply_format_unit(input,format, unit);
  }

  static apply_format_unit_raw(input, format, unit) {
    //For Rupees Cr.
    if ((format && format.substring(format.length - 3) === "INR") || format === "Rs") {
      return " rupees";
    } else if (unit == "Period") {
      return " days"; // numeral(input).format("00.0"); //+ "days";
    } else if (unit == "ShortTextPeriod") {
      return " days"; //numeral(input).format("00.0"); //+ "days";
    } else if (unit.toLowerCase() == "percentage") {
      return "%";
    } else {
      return "";
      //  numeral(input).format(format);
    }
  }

  static apply_format_2(input, format, unit) {
    //For Rupees Cr.
    if (format && format.substring(format.length - 3) === "INR") {
      var negSign = "";
      if (input < 0) {
        negSign = "-";
        input *= -1;
      }
      var otherFormat = format && format.substring(0, format.length - 3);
      var abbr = "";
      if (input >= Math.pow(10, 7)) {
        // Cr.
        abbr = "Cr.";
        input = input / Math.pow(10, 7);
      } else if (input < Math.pow(10, 7) && input >= Math.pow(10, 5)) {
        // Lacs.
        abbr = "L";
        input = input / Math.pow(10, 5);
      } else if (input < Math.pow(10, 5) && input >= Math.pow(10, 3)) {
        // Thousands
        abbr = "K";
        input = input / Math.pow(10, 3);
      } else {
        //Less than thousand
        input = input;
      }
      return negSign + "" + numeral(input).format(otherFormat); //+ abbr;
    } else if (unit == "Period") {
      var abbr = "day";
      if (input >= 365) {
        return numeral(input / 365).format("00.0"); // + "years";
      } else if (input >= 30) {
        return numeral(input / 30).format("00.0"); //+ "months";
      } else {
        return numeral(input).format("00.0"); //+ "days";
      }
    } else if (unit == "ShortTextPeriod") {
      var abbr = "day";
      if (input >= 365) {
        return numeral(input / 365).format("00.0"); //+ "yrs";
      } else if (input >= 30) {
        return numeral(input / 30).format("00.0"); //+ "mths";
      } else {
        return numeral(input).format("00.0"); //+ "days";
      }
    } else {
      return numeral(input).format(format);
    }
  }
  static date_format(date, format) {
    if ((date != undefined && (typeof date == "string" && date.toLowerCase() != "invalid date")) || typeof date == "object") {
      return dateFormat(date, format);
    } else {
      return "N/A";
    }
  }
  static compareStrings(a,b){
    if(!a || !b){
      return a == b;
    }else{
      return a.toString().trim().toLowerCase() === b.toString().trim().toLowerCase();
    }
  }
  static _searchAll(searchString, data, searchKeys) {
    var that = this;
    if (Object.prototype.toString.call(searchString) !== "[object Array]") {
      searchString = [searchString];
    }
    return searchString.every(function(_searchString) {
      return that._search(_searchString, data, searchKeys,0);
    });
  }

  static _search(searchString, data, searchKeys, depth) {
    var that = this;
    var typeOfData = typeof data;
    switch (typeOfData) {
      case "object":
        {
          try {
            var keys = Object.keys(data).filter(function(d) {
              return !searchKeys[depth] || searchKeys[depth].length == 0 || searchKeys[depth].indexOf(d) > -1;
            });
            var found = false;
            for (var i = 0; i < keys.length && found == false; i++) {
              found = that._search(searchString, data[keys[i]], searchKeys, depth + 1);
            }
            return found;
          } catch (e) {
            //nothing to handle
            return false;
          }
          break;
        }
      case "number":
        {
          data = data.toString();
        }
      case "string":
        {
          if (data.search(new RegExp(searchString, "i")) === -1) {
            return false;
          } else {
            return true;
          }
          break;
        }
      default:
        {
          return false;
        }
    }
    return false;
  }
}
